const IspIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="100%"
            height="100%"
            viewBox="-0.5 -0.5 600 634"
        >
            <defs />
            <g>
                <image
                    x="-146"
                    y="-0.5"
                    width="900"
                    height="634"
                    xlinkHref="data:image/svg+xml,%3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='720.000000pt' height='507.000000pt' viewBox='0 0 720.000000 507.000000' preserveAspectRatio='xMidYMid meet'%3E%3Cdefs/%3E%3Cg transform='translate(0.000000,507.000000) scale(0.100000,-0.100000)'%0Afill='%232A4E69' stroke='none'%3E%3Cpath d='M2544 4656 c-17 -8 -44 -31 -60 -52 l-29 -37 0 -2032 0 -2032 29 -37%0Ac53 -70 -13 -66 1116 -66 1129 0 1063 -4 1116 66 l29 37 0 2032 0 2032 -29 37%0Ac-53 70 13 66 -1118 66 -839 -1 -1029 -3 -1054 -14z m1934 -858 l2 -548 -880%0A0 -880 0 0 544 c0 426 3 545 13 549 6 3 401 4 877 3 l865 -1 3 -547z m-741%0A-1819 c99 -48 153 -130 161 -245 6 -101 -16 -163 -82 -230 -126 -126 -311%0A-125 -433 2 -66 69 -87 129 -81 228 6 81 28 132 83 189 94 97 223 118 352 56z%0Am683 -1169 l0 -60 -820 0 -820 0 0 60 0 60 820 0 820 0 0 -60z'/%3E%3Cpath d='M2832 4043 l3 -188 765 0 765 0 3 188 2 187 -770 0 -770 0 2 -187z'/%3E%3Cpath d='M2830 3550 l0 -190 770 0 770 0 -2 188 -3 187 -767 3 -768 2 0 -190z'/%3E%3Cpath d='M3512 1879 c-106 -53 -133 -196 -55 -290 91 -108 268 -77 319 56 62%0A162 -107 311 -264 234z'/%3E%3C/g%3E%3Ctext fill='%23ffffff' x='50%25' y='52.5%25' alignment-baseline='middle' text-anchor='middle' font-size='58' font-weight='600' font-style='italic'%0A%3E ISP2%0A%3C/text%3E%3C/svg%3E%0A"
                    preserveAspectRatio="none"
                />
            </g>
        </svg>
    );
};

export default IspIcon;
